<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful title="Delete Employee Recognition :: MeritEHS"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/employees/recognition-list`">
                            <i class="fa fa-trophy"></i> Recognitions
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/employees/recognition/view/${recognition_id}`">
                            {{ recognition.employee_first_name }} {{ recognition.employee_last_name }} for {{ recognition.recognition_name }} on {{ recognition.recognition_date | moment("MM/DD/YYYY") }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        <i class="fa fa-trash"></i> Delete
                    </li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-xl-8 col-12">
                    <div class="card mb-3">
                        <div class="card-header">
                            Delete Recognition
                        </div>
                        <div class="card-body">
                            <div class="alert alert-danger">
                                <strong>Warning:</strong> You are about to delete this recognition. This cannot be undone.
                            </div>
                        </div>
                        <div class="card-footer">
                            <button type="button" class="btn btn-danger" v-on:click="deleteRecog()" :disabled="deleting">
                                <template v-if="deleting">
                                    Deleting...
                                </template>
                                <template v-else>
                                    Delete
                                </template>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                userTimezone: this.$store.state.user.timezone,
                deleting: false,
                recognition_id: this.$route.params.id,
                recognition: {},
                errors: {},
            }
        },

        computed: {
            creator() {
                return {
                    FirstName: this.recognition.creator_first_name,
                    LastName: this.recognition.creator_last_name,
                    deleted_at: this.recognition.creator_deleted_at,
                };
            },
        },

        methods: {

            getRecognition: function() {
                //Loading
                this.loading = true;

                //Get the data
                this.$http
                    .get(`employees/recognition/view/${this.recognition_id}`)
                    .then(response => {
                        //Set all the data
                        this.recognition = response.data.recognition;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            deleteRecog(){
                //Flag
                this.deleting = true;

                //Sent it
                this.$http
                    .post(`employees/recognition/delete/${this.recognition_id}`)
                    .then(response => {
                        //Set loading
                        this.loading = false;

                        //Alert
                        this.$toastr.success('Recognition Deleted');

                        //Send to list
                        this.$router.push('/employees/recognition-list');
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //Reset
                        this.deleting = false;
                    });
            },

        },
        mounted() {
            //Get the users
            this.getRecognition();
        }
    }
</script>
